import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CHECKBOX, EMPTY_COLUMN, FILE, IMAGE_FILE, MARKDOWN, RADIO, SELECT, TEXT, TYPOGRAPHY, VIDEO_FILE } from '../../constants/formInputTypes';
import { permissionNames, stateValuesByAction } from '../../constants/permissions';
import { CheckboxController, FileController, MarkdownController, RadioController, SelectController, TextController, TypographyController, VideoController } from './GenerateFormHookControllers';

const useStyles = makeStyles((theme) => ({
    root: {},
    gridItem: {
        padding: theme.spacing(1.5),
    },
    label: {
        "& .Mui-required .MuiFormLabel-asterisk": {
            color: theme.palette.ascents.orange,
        },
    },
    checkLabel: {
        "& .MuiTypography-body1": {
            fontSize: "12px",
        },
    },
    receiptBookButton: {
        marginTop: theme.spacing(1.75),
    }
}));

const GenerateFormHook = ({
    formConstant = [],
    eachWidth = 4,
    gridContainerClassName,
    gridContainerProps = {},
    control,
    formStatus,
    ...props
}) => {
    const classes = useStyles();
    const { errors } = useFormContext();

    const renderForm = () => {
        return formConstant.filter(formObj => {
            if (formObj.fieldType === VIDEO_FILE || formObj.fieldType === IMAGE_FILE) {
                return (
                    (stateValuesByAction[permissionNames.CAN_APPROVE_STAGE_II] == String(formStatus))
                    || (stateValuesByAction[permissionNames.CAN_APPROVE_STAGE_I] == String(formStatus))
                    || (stateValuesByAction[permissionNames.CAN_DISAPPROVE_STAGE_II] == String(formStatus))
                    || ((stateValuesByAction[permissionNames.CAN_ARCHIVE] == String(formStatus)))
                    || ((stateValuesByAction[permissionNames.CAN_UNPUBLISH] == String(formStatus)))
                    || ((stateValuesByAction[permissionNames.CAN_PUBLISH] == String(formStatus)))
                ) ? true : false;
            }
            return true;
        }).map((formObj, idx) => {
            switch (formObj.fieldType) {
                case TEXT:
                    return (
                        <TextController
                            key={idx}
                            formObj={formObj}
                            classes={classes}
                            control={control}
                            eachWidth={eachWidth}
                            errors={errors}
                        />
                    )

                case SELECT:
                    return (
                        <SelectController
                            key={idx}
                            formObj={formObj}
                            classes={classes}
                            control={control}
                            eachWidth={eachWidth}
                            errors={errors}
                        />
                    )

                case VIDEO_FILE:
                    return (
                        <VideoController
                            key={idx}
                            formObj={formObj}
                            classes={classes}
                            control={control}
                            eachWidth={eachWidth}
                            fileType={VIDEO_FILE}
                            collapsible={{
                                wrapInCollapsible: false,
                                collapsibleIsOpen: false
                            }}
                            previewUrl={formObj.previewUrl}
                        />
                    )

                case IMAGE_FILE:
                    return (
                        <FileController
                            key={idx}
                            formObj={formObj}
                            classes={classes}
                            control={control}
                            eachWidth={eachWidth}
                            fileType={IMAGE_FILE}
                            collapsible={{
                                wrapInCollapsible: false,
                                collapsibleIsOpen: false
                            }}
                            previewUrl={formObj.previewUrl}
                        />
                    )


                case FILE:
                    return (
                        <FileController
                            key={idx}
                            formObj={formObj}
                            classes={classes}
                            control={control}
                            eachWidth={eachWidth}
                            fileType={FILE}
                            collapsible={{
                                wrapInCollapsible: false,
                                collapsibleIsOpen: false
                            }}
                            previewUrl={formObj.previewUrl}
                        />
                    )

                case CHECKBOX:
                    return (
                        <CheckboxController
                            key={idx}
                            formObj={formObj}
                            classes={classes}
                            control={control}
                            eachWidth={eachWidth}
                        />
                    )
                case TYPOGRAPHY:
                    return (
                        <TypographyController
                            key={idx}
                            classes={classes}
                            as={formObj.as}
                            label={formObj.label}
                            eachWidth={formObj.eachWidth}
                        />
                    )

                case RADIO:
                    return (
                        <RadioController
                            key={idx}
                            classes={classes}
                            control={control}
                            formObj={formObj}
                            eachWidth={eachWidth}
                        />
                    )

                case MARKDOWN:
                    return (
                        <MarkdownController
                            key={idx}
                            classes={classes}
                            control={control}
                            formObj={formObj}
                            eachWidth={eachWidth}
                        />
                    )
                case EMPTY_COLUMN:
                    return (
                        <Grid item xs={formObj.eachWidth || eachWidth} />
                    )

                default:
                    return (
                        <TextController
                            key={idx}
                            formObj={formObj}
                            classes={classes}
                            control={control}
                            eachWidth={formObj.eachWidth || eachWidth}
                        />
                    );
            }
        })
    }

    return (
        <Grid container className={gridContainerClassName} {...gridContainerProps}>
            {renderForm()}
        </Grid>
    )
}

export default GenerateFormHook
